import React from 'react';

const QuotePage = React.lazy(() => import('pages/PriceQuote/pages/QuotePage'));
const QuoteAdd = React.lazy(() => import('pages/PriceQuote/pages/QuoteAdd'));

const Quote = [
  {
    path: '/quote',
    exact: true,
    name: 'Danh sách báo giá',
    function: 'PRICEQUOTE_VIEW',
    component: QuotePage,
  },
  {
    path: '/quote/add',
    exact: true,
    name: 'Thêm mới báo giá',
    function: 'PRICEQUOTE_ADD',
    component: QuoteAdd,
  },
  {
    path: '/quote/add/:id',
    exact: true,
    name: 'Sao chép báo giá',
    function: 'PRICEQUOTE_ADD',
    component: QuoteAdd,
  },
  {
    path: '/quote/detail/:id',
    exact: true,
    name: 'Chi tiết báo giá',
    function: ['PRICEQUOTE_VIEW', 'PRICEQUOTE_ADD', 'PRICEQUOTE_EDIT'],
    any: true,
    component: QuoteAdd,
  },
  {
    path: '/quote/edit/:id',
    exact: true,
    name: 'Chỉnh sửa báo giá',
    function: 'PRICEQUOTE_EDIT',
    component: QuoteAdd,
  },
];

export default Quote;
